import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import ListGroupItem from 'reactstrap/lib/ListGroupItem'

export interface IProgressChecklistItem {
  isComplete: boolean
  isVisible?: boolean
  label: string
  children?:
    | React.ReactElement<IProgressChecklistItem>
    | Array<React.ReactElement<IProgressChecklistItem>>
}

export class ProgressChecklistItem extends React.PureComponent<IProgressChecklistItem> {
  public render() {
    if (this.props.isVisible === false) {
      return null
    }

    const iconName = this.props.isComplete ? 'check' : 'times'
    const iconClasses = this.props.isComplete ? 'text-success' : 'text-danger'

    return (
      <ListGroupItem style={{ padding: 2, marginLeft: 16 }}>
        <div>
          <FontAwesomeIcon
            className={iconClasses}
            icon={['far', iconName]}
            fixedWidth
            size='lg'
          />{' '}
          {this.props.label}
        </div>
        {this.props.children && <ul>{this.props.children}</ul>}
      </ListGroupItem>
    )
  }
}
